import React from 'react';
import { ToastContainer } from 'react-toastify';
import ReactGA from "react-ga4";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from './modules/PublicHeader';
import { notify } from "../services/NotificationService";
import '../assets/css/global.css';

// Coquille des pages publiques sans client identifié : connexion,
// réinitialisation de mot de passe, inscription, contact, catalogue public.
const AUTH_PATHS = ["/login", "/reset", "/inscription", "/new-password"];

export default function Root() {
    const location = useLocation();
    const isAuthPage = AUTH_PATHS.some((path) => location.pathname.startsWith(path));

    notify();

    if (window.location.href.indexOf("localhost") === -1) {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: window.location.pathname });
    }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />

            <PublicHeader hideLoginLink={isAuthPage} />

            <main id="detailPublic" className={`lk-public-main${isAuthPage ? " lk-public-main--auth" : ""}`}>
                <Outlet />
            </main>
        </>
    );
}
